import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const LegendCell = ({title, styleName, onClick}) => (
  <div className={`LegendCell LegendCell--${styleName}`} onClick={onClick}>
    <p className={classNames("LegendCell__title")}>{title}</p>
  </div>
);

LegendCell.propTypes = {
  title: PropTypes.string.isRequired,
  styleName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default LegendCell;



// WEBPACK FOOTER //
// ./src/components/LegendCell.js